<img [src]="materialUrl" class="img-fluid" />
